<footer id="footer">
    <div class="footer-top">
        <div class="container">
            <div class="row">

                <div class="col-lg-4 col-md-4 footer-links">
                    <div class="footer-info">
                        <div class="logo">
                            <a href="index.html">
                                <img src="../../../assets/images/home-page/footer-logo.png" alt="" style="width: 91px;">
                            </a>
                        </div>

                        <div class="address">
                            <p>
                                9th Floor, Office No.909, Lotus Surprising <br>City, Link Road, Near Audi Showroom,<br>
                                Andheri West, Mumbai - 400053, India
                            </p>
                        </div>
                        <ul class="socialIcons">
                            <li><a href="tel:9930000375" target="_blank">
                                    <div class="icon">
                                        <img src="assets/images/home-page/footericon.svg" alt="">
                                    </div> +91 99300 00375
                                </a></li>
                            <li><a href="mailto:support@tplsport.com" target="_blank">
                                    <div class="icon">
                                        <img src="assets/images/home-page/footericon2.svg" alt="">
                                    </div>
                                    support@tplsport.com
                                </a></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-2 col-md-4 footer-links">
                    <h4>important links</h4>
                    <ul>

                        <li>



                            <a [routerLink]="['/home']">Home</a>
                        </li>
                        <li>

                            <a [routerLink]="['/tournaments']">Tournaments</a>

                        </li>
                        <li>

                            <a [routerLink]="['/academies']">Academies</a>

                        </li>
                        <li>

                            <a   class="cursor-pointer"  (click)="onDownloadClick('bottom')">Book A Court</a>

                        </li>
                        <li>

                            <a  class="cursor-pointer" [routerLink]="['/find-partner']">Find A Partner</a>

                        </li>



                    </ul>


                </div>
                <div class="col-lg-2 col-md-4 footer-links">
                    <h4>Internal Useful Link</h4>
                    <ul>

                        <li>
                            <a [routerLink]="['/about-the-league']">About TPL</a>
                        </li>
                        <li>
                            <a [routerLink]="['/faq']">FAQ’s</a>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-2 col-md-4 footer-links">
                    <h4>General Links</h4>
                    <ul>

                        <li>
                            <a [routerLink]="['/termsandcondition']">Terms and Conditions</a>
                        </li>
                        <li>
                            <a [routerLink]="['/refund-policy']">Refund Policy</a>
                        </li>
                        <li>
                            <a [routerLink]="['/data-protection-policy']">Data Protection Policy</a>
                        </li>
                        <li>
                            <a [routerLink]="['/privacy-policy']">Privacy Policy</a>
                        </li>
                        <li>
                            <a [routerLink]="['/cookie-policy']">Cookie Policy</a>
                        </li>
                        <!-- <li> 
                            <a href="/change-log">Change Log</a>
                        </li> -->
                        <li>
                            <a [routerLink]="['/delete-account']">Delete Account</a>
                        </li>
                        <li>
                            <a [routerLink]="['/contact-us']">Contact Us</a>
                        </li>


                    </ul>
                </div>

                <div class="col-lg-2 col-md-4 footer-newsletter">
                    <h4>JOIN OUR NEWSLETTER</h4>
                    <!-- <p>Be the first to learn about our latest News and Matches </p> -->
                    <form [formGroup]="subscribeForm" (ngSubmit)="onSubmit()">

                        <input type="email" class="form-control" name="email" for="email"
                            class="email-input form-control" formControlName="email" type="email"
                            placeholder="Enter your email" [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                            placeholder="Enter your email" required>
                        <div class="input-group-append">
                            <button>
                                <img src="../../../assets/images/home-page/submit.svg" alt="">
                            </button>
                        </div>
                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback col-md-auto">
                            <div *ngIf="f.email.errors.required">Email is required</div>
                            <div *ngIf="f.email.errors.email">Enter valid email address</div>
                        </div>
                        <div *ngIf="showSuccess" class="success-feedback col-md-auto">
                            Subscribed Successfully
                        </div>
                    </form>

                    <div class="followUs">
                        <h6 class="follow-heading">FOLLOW US ON</h6>
                        <div class="social-links ">
                            <a href="https://www.instagram.com/tennispremierleague/" class="instagram" target="_blank">
                                <img src="../../../assets/images/footer/instagram.svg" alt="">
                            </a>

                            <a href="https://www.facebook.com/tennispremierleague/" class="facebook" target="_blank">
                                <img src="../../../assets/images/footer/facebook.svg" alt="">
                            </a>

                            <a href="https://www.linkedin.com/company/tennis-premier-league/?originalSubdomain=in"
                                class="linkedin" target="_blank">
                                <img src="../../../assets/images/footer/linkdin.svg" alt="">
                            </a>
                            <a href="https://www.youtube.com/channel/UCwzZgIn3_q15e9mcoSvyJbg" class="youtube"
                                target="_blank">
                                <img src="../../../assets/images/footer/youtube.svg" alt="">
                            </a>
                            <!-- <a href="javascript:void(0)" class="google-plus"><i class="bx bxl-skype"></i></a>
                        <a href="javascript:void(0)" class="linkedin"><i class="bx bxl-linkedin"></i></a> -->
                        </div>
                    </div>


                </div>

            </div>
        </div>
    </div>
</footer>
<div class="barfooter">
    <div class="footerListMenues">
        <ul>
            <li>
                <a routerLink="/tournaments" [routerLinkActive]="'active' ">
                    <div class="icon">
                        <img src="../../../assets/images/footer/trophy.svg" alt="">
                    </div>
                    <div class="title">
                        <h6 class="navBold">Tournaments</h6>
                    </div>
                </a>

            </li>
            <li>
                <a routerLink="academies" [routerLinkActive]="'active'" [queryParams]="{ page:1, limit: 10}" >
                    <div class="icon">
                        <img src="../../../assets/images/footer/tennis-racket.svg" alt="">
                    </div>
                    <div class="title">
                        <h6 class="navBold">ACADEMIES</h6>
                    </div>
                </a>

            </li>
            <li class="homeBtnList">
                <div class="homeBtn">
                    <a  routerLink="/home">
                        <div class="iconmain">
                            <img src="../../../assets/images/footer/ball.png" alt="">
                        </div>
                    </a>
                </div> 
            </li>
            <li>
                <a (click)="onDownloadClick('bottom')">
                    <div class="icon">
                        <img src="../../../assets/images/footer/court.svg" alt="">
                    </div>
                    <div class="title">
                        <h6 class="navBold">BOOK A COURT</h6>
                    </div>
                </a>

            </li>
            <li>
                <a  routerLink="find-partner" [queryParams]="{ page:1, limit: 10}"  [routerLinkActive]="'active'">
                    <div class="icon">
                        <img src="../../../assets/images/footer/tennis-player-with-racket.svg" alt="">
                    </div>
                    <div class="title">
                        <h6 class="navBold">FIND A PARTNER</h6>
                    </div>
                </a>

            </li>
        </ul>
    </div>
</div>

<!-- <div class="mobileversion-footer" id="footer-mobile-nav">
    <ul *ngIf="!aboutTpl">
       
        <li class="mobile-footer " routerLink="about-the-league" *ngIf="currentActiveRoute === null" (click)="onClickCurrentTab('/about-the-league')" [routerLinkActive]="'active' ">
            <a> <img src="../../../assets/img/home/m10.svg" alt="" style="padding: 1px;">
                <span class="title">About TPL</span>
            </a>
        </li>
        <li class="mobile-footer" routerLink="contest" [routerLinkActive]="'active' " *ngIf="currentActiveRoute === null || currentActiveRoute !== 'contest'" (click)="onClickCurrentTab('/contest')">
            <a><img src="../../../assets/img/home/footer21.svg" alt="">
                <span class="title">Contest</span>
            </a>
        </li> 
        <li class="mobile-footer" routerLink="/find-partner" [routerLinkActive]="'active' " *ngIf="currentActiveRoute !== null && currentActiveRoute !== 'findPartner'" (click)="onClickCurrentTab('/find-partner')">
            <a><img src="../../../assets/img/home/Find-A-Partner.svg" alt="">
                <span class="title">Find Partner</span>
            </a>
        </li> 
        <li class="mobile-footer" routerLink="/product" [routerLinkActive]="'active' " *ngIf="currentActiveRoute !== null && (currentActiveRoute !== 'eshop' && currentActiveRoute !== 'leaderboard') && (currentActiveRoute === 'contest' || currentActiveRoute === 'findPartner')" (click)="onClickCurrentTab('/product')">
            <a><img src="../../../assets/img/home/m8.svg" alt="" style="filter: invert(57%) sepia(2%) saturate(30%) hue-rotate(15deg) brightness(91%) contrast(94%);">
                <span class="title">Shop</span>
            </a>
        </li> 
        <li class="mobile-footer homebtn" routerLink="home" [routerLinkActive]="'active' " (click)="onClickCurrentTab('/home')">
            <a>
                <span class="main-icon"> 
                    <img src="../../../assets/img/home/homenew.svg" alt="">
                    <span class="title">Home</span>
                </span>

            </a>
            <div class="corners"></div>
        </li>

        <li class="mobile-footer" routerLink="/product" [routerLinkActive]="'active' " *ngIf="currentActiveRoute !== null && (currentActiveRoute !== 'eshop' && currentActiveRoute !== 'leaderboard') && (currentActiveRoute === 'academy' || currentActiveRoute === 'tournaments')" (click)="onClickCurrentTab('/product')">
            <a><img src="../../../assets/img/home/m8.svg" alt="" style="filter: invert(57%) sepia(2%) saturate(30%) hue-rotate(15deg) brightness(91%) contrast(94%);">
                <span class="title">Shop</span>
            </a>
        </li> 

        <li class="mobile-footer" routerLink="/academies" [routerLinkActive]="'active' " *ngIf="currentActiveRoute !== null && currentActiveRoute !== 'academy'" (click)="onClickCurrentTab('/academies')">
            <a><img src="../../../assets/img/home/m6.svg" alt="" style="filter: invert(57%) sepia(2%) saturate(30%) hue-rotate(15deg) brightness(91%) contrast(94%);">
                <span class="title">Academies</span>
            </a>
        </li> 
    
    

    
        <li class="mobile-footer" routerLink="tournaments" [routerLinkActive]="'active' " *ngIf="currentActiveRoute === null || currentActiveRoute !== 'tournaments'" (click)="onClickCurrentTab('/tournaments')">
            <a> <img src="../../../assets/img/home/Tournament.svg" alt="" style="filter: invert(57%) sepia(2%) saturate(30%) hue-rotate(15deg) brightness(91%) contrast(94%);">
                <span class="title">Tournaments</span>
            </a>
        </li> 
        <li class="mobile-footer" routerLink="media" [routerLinkActive]="'active' " *ngIf="currentActiveRoute === null">
            <a><img src="../../../assets/img/home/news-icon.svg" alt="">
                <span class="title">News</span>
            </a>
        </li> 
    </ul>


    <ul *ngIf="aboutTpl">
       
        <li class="mobile-footer " routerLink="about-the-league" *ngIf="currentActiveRoute !== 'abouttheleague'" (click)="onClickCurrentTab('/about-the-league')" [routerLinkActive]="'active' ">
            <a> <img src="../../../assets/img/home/About-TPL.svg" alt="" style="padding: 1px;">
                <span class="title">About TPL</span>
            </a>
        </li>
        <li class="mobile-footer" routerLink="scoretable" [routerLinkActive]="'active' " *ngIf="currentActiveRoute !== 'standings'" (click)="onClickCurrentTab('/scoretable')">
            <a><img src="../../../assets/img/home/Standings.svg" alt="">
                <span class="title">Standings</span>
            </a>
        </li> 
        <li class="mobile-footer" routerLink="/teams" [routerLinkActive]="'active' " *ngIf="currentActiveRoute !== 'teams' && (currentActiveRoute === 'abouttheleague' || currentActiveRoute === 'standings')" (click)="onClickCurrentTab('/teams')">
            <a><img src="../../../assets/img/home/footer24.svg" alt="">
                <span class="title">Teams</span>
            </a>
        </li> 
        <li class="mobile-footer homebtn" routerLink="home" [routerLinkActive]="'active' " (click)="onClickCurrentTab('/home')">
            <a>
                <span class="main-icon"> 
                    <img src="../../../assets/img/home/homenew.svg" alt="">
                    <span class="title">Home</span>
                </span>

            </a>
            <div class="corners"></div>
        </li>

        <li class="mobile-footer" routerLink="/teams" [routerLinkActive]="'active' " *ngIf="currentActiveRoute !== 'teams' && (currentActiveRoute === 'sponsors' || currentActiveRoute === 'media' || currentActiveRoute === 'highlights')" (click)="onClickCurrentTab('/teams')">
            <a><img src="../../../assets/img/home/footer24.svg" alt="">
                <span class="title">Teams</span>
            </a>
        </li> 

        <li class="mobile-footer" routerLink="/sponsors" [routerLinkActive]="'active' " *ngIf="currentActiveRoute !== 'sponsors'" (click)="onClickCurrentTab('/sponsors')">
            <a><img src="../../../assets/img/home/Sponsors.svg" alt="" style="filter: invert(57%) sepia(2%) saturate(30%) hue-rotate(15deg) brightness(91%) contrast(94%);">
                <span class="title">Sponsors</span>
            </a>
        </li> 
    
        <li class="mobile-footer" routerLink="media" [routerLinkActive]="'active' " *ngIf="(currentActiveRoute !== 'media' && currentActiveRoute !== 'highlights')" (click)="onClickCurrentTab('/media')">
            <a> <img src="../../../assets/img/home/media.svg" alt="" style="filter: invert(57%) sepia(2%) saturate(30%) hue-rotate(15deg) brightness(91%) contrast(94%);">
                <span class="title">Media</span>
            </a>
        </li> 
    </ul>
</div> -->

<p-dialog [closable]="true" [(visible)]="downloadModal" [modal]="true" [style]="{width: '416px'}"
    id="downloadModalPopup" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false" [closable]="false" [position]="position">
    <div class="downloadbody">
        <div class="topleftbg">
            <img src="../../../../assets/images/download/topleft.png" alt="">
        </div>
        <div class="bottomrightbg">
            <img src="../../../../assets/images/download/bottomright.png" alt="">
        </div>
        <div class="bottomleftbg">
            <img src="../../../../assets/images/download/bottomleft.png" alt="">
        </div>
        <div class="download-header">
            <button (click)="downloadModal = false" class="closeBtn">
                <img src="assets/images/download/close.svg" alt="">
            </button>
        </div>
        <div class="bannerImage">
            <img src="../../../../assets/images/download/leander.png" alt="">
        </div>
        <div class="modalTitleImage">
            <img src="../../../../assets/images/download/modalTile.svg" alt="">
        </div>

        <div class="downloadList">
            <ul>
                <li>
                    <a href="https://play.google.com/store/apps/details?id=com.wiantech.tplsport&pcampaignid=web_share">
                        <img src="../../../../assets/images/download/btn1.png" alt="">
                    </a>
                </li>
                <li>
                    <a href="https://apps.apple.com/in/app/tpl-tennis-premier-league/id6461867254">
                        <img src="../../../../assets/images/download/btn2.png" alt="">
                    </a>
                </li>
            </ul>
        </div>

        <div class="orTitle">
            <div class="line"></div>
            <p>OR</p>
            <div class="line"></div>
        </div>
        <div class="scanner">
            <img src="../../../../assets/images/download/qrcode.png" alt="">
        </div>
        <div class="notesdiv">
            <p>Click the buttons above to download the <span>App!</span></p>
        </div>
    </div>
</p-dialog>
